export const createScrollOffsetWithinBounds = ({
  currentScrollOffset,
  maxScrollOffset,
  direction = 'next',
  step = 120,
}: {
  currentScrollOffset: number;
  maxScrollOffset: number;
  direction?: 'prev' | 'next';
  step?: number;
}) => {
  const newScrollOffset = currentScrollOffset + (direction === 'prev' ? -step : step);
  return Math.max(0, Math.min(maxScrollOffset, newScrollOffset));
};
